import type { JSX } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Chip from '@mui/material/Chip';
import CloudIcon from '@mui/icons-material/Cloud';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { formatDate, formatAddress } from '@footsteps/shared';
import { useWozCaseManager } from '../woz-case-manager.provider';

type WozCasePickerModalProps = {
  open: boolean;
  onClose: () => void;
};

export const WozCasePickerModal = ({ open, onClose }: WozCasePickerModalProps): JSX.Element => {
  const { caseManagerState, caseManagerViewModel } = useWozCaseManager();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Selecteer een bezwaar
        <IconButton aria-label='sluiten' onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <List>
          {caseManagerState.cases.openCases.map((wozCase, index) => (
            <ListItemButton
              key={`woz-case-picker-${index}`}
              onClick={() => caseManagerViewModel.selectCase(wozCase)}
              sx={{
                borderLeft: 3,
                borderColor: wozCase.source === 'database' ? 'primary.main' : 'warning.main',
                mb: 1,
                borderRadius: 1,
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                {wozCase.source === 'database' ? <CloudIcon color='primary' /> : <PhoneAndroidIcon color='warning' />}
              </ListItemIcon>
              <ListItemText
                primary={formatAddress(wozCase)}
                secondary={`Laatst gewijzigd: ${formatDate(wozCase.updatedAt)}`}
              />
              <Chip
                label={wozCase.source === 'database' ? 'Opgeslagen' : 'Niet opgeslagen'}
                size='small'
                color={wozCase.source === 'database' ? 'primary' : 'warning'}
                variant='outlined'
                sx={{ ml: 1 }}
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuleren</Button>
      </DialogActions>
    </Dialog>
  );
};
